import React from "react";
import PropTypes from "prop-types";
import { translate } from "react-i18next";
import Flow from "../components/Flow";
import { EmailStep, NamePhoneCodeStep, CompanyStep } from "../steps";
import Sidebar from "../components/StandardSidebar";
import StepFooter from "../components/StepFooter";

const DefaultFlow = ({ t, onComplete, ...props }) => {
	const domainLoginMap = {
		"https://signup.au.damstralearning.com/":
			"https://app.au.damstralearning.com/",
		"https://signup.eu.learning.ideagen.com/":
			"https://app.eu.learning.ideagen.com/",
		"https://signup.us.damstralearning.com/":
			"https://app.us.damstralearning.com/",
		"https://qa-signup.velpic.com/": "https://qa-app.velpic.com/",
		"https://signup.dev.damstralearning.com/":
			"https://app.dev.damstralearning.com/",
	};

	const currentUrl = new URL(window.location.href);
	const baseUrl = `${currentUrl.protocol}//${currentUrl.host}${currentUrl.pathname}`;
	const loginUrl = domainLoginMap[baseUrl] || "https://app.velpic.com/";

	return (
		<div className="flow-container">
			<div className="flow-title">
				<h1>{t("defaultFlowTitle")}</h1>
			</div>
			<div className="step container p-0 d-flex flex-md-row flex-column ">
				<div className="d-flex flex-column flow-form-container">
					<Flow onComplete={onComplete} {...props}>
						<EmailStep />
						<NamePhoneCodeStep />
						<CompanyStep />
					</Flow>
					<StepFooter loginUrl={loginUrl} className="mt-auto text-center" />
				</div>
				<Sidebar />
			</div>
		</div>
	);
};

DefaultFlow.propTypes = {
	t: PropTypes.func.isRequired,
	onComplete: PropTypes.func.isRequired,
};

export default translate()(DefaultFlow);
